/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';
const addToCartSingle = {
	/**
	 * @description Cache dom and strings
	 * @description Please always define selectors, classes and data attributes with the following prefixes
	 * @type {object}
	 * @param {jQuery} $dom	for any jQuery selectors
	 * @param {string} class for any class strings
	 * @param {string} attr for any data attributes strings
	 */

	$minus: $('.js-qty-minus'),
	$plus: $('.js-qty-plus'),
	$flag: false,
	$cartHeader: $('#cartId'),
	$single: $('#singleInput'),
	$index: 0,
	CartUpdateTimeout: {},

	/**
	 * @description Initialize
	 * @example this.someFunction();
	 */
	init: () => {
        // delegated events on "search" page
        /* $('.js-search-wrap').on('keyup', '.js-search-res-input', addToCartSingle.onSearchPageQuantityKeyUp); */

        // delegated events
        $('body').on('click', '.js-qty-plus', addToCartSingle.onQuantityPlus);
        $('body').on('click', '.js-qty-minus', addToCartSingle.onQuantityMinus);

        // on single-product page
		$(addToCartSingle.$single).on('keyup', addToCartSingle.onSingleProductQuantityKeyUp);

		// Add event listeners for focus, blur, and keyup for search input fields
        $('.js-search-res-input').on('focus', addToCartSingle.handleFocus)
                                 .on('blur', addToCartSingle.handleBlur)
                                 .on('keyup', addToCartSingle.onSearchPageQuantityKeyUp);

		$('#singleInputShow').on('keyup', addToCartSingle.onSearchPageQuantityKeyUp);
	},

	handleFocus: function() {
        $(this).data('placeholder', $(this).attr('placeholder')); // Store the current placeholder
        $(this).attr('placeholder', ''); // Clear the placeholder when focused
    },

    /**
     * Handles the blur event for input fields
     */
    handleBlur: function() {
		const value = $(this).val().trim();
		if (value === "" || parseInt(value, 10) === 0) {
			$(this).val(''); // Clear value
			$(this).attr('placeholder', '0'); // Set placeholder
		}
	},

    /* onSearchPageQuantityKeyUp: function(ev) {
        const input = $(this).parent().find('input:last');
        const pack = 1; //$(this).attr('data-pack');
        const valG = $(this).val();
        let newVal = '';

        if(valG.length > 1) {
            if(valG.charAt(0) == 0) {
                newVal = valG.substring(1);
                $(this).val(newVal);
            } else {
                newVal = valG;
            }
        }
        // Prevent user from entering dot
        if (ev.keyCode === 190 || ev.keyCode === 110) {
            newVal = valG.substring(0, valG.length - 1);
        }

        let val = parseInt(newVal, 10) || 0;

		if (val <= 0) {
            val = 0;
            $(this).val(0);
        }
        $(this).val(val);

        // eslint-disable-next-line no-unused-vars
        const inputpack = parseInt(newVal, 10) || 1;
        const id = $(input).attr('data-id');
        const index = $(this).attr('data-index');
        addToCartSingle.delayedSendQty(id, index, pack, val);
    }, */

	onSearchPageQuantityKeyUp: function(ev) {
		const input = $(this).parent().find('input:last');
		const pack = 1; // or $(this).attr('data-pack');
		let valG = $(this).val();

		// Remove leading zeros (but allow a single 0)
		if (valG.length > 1 && valG.charAt(0) == '0') {
			valG = valG.substring(1);
			$(this).val(valG);
		}

		// Prevent dot input
		if (ev.keyCode === 190 || ev.keyCode === 110) {
			valG = valG.slice(0, -1);
			$(this).val(valG);
		}

		// If input is empty or non-numeric, skip processing to avoid turning it into 0
		if (!/^\d+$/.test(valG)) {
			return;
		}

		const val = parseInt(valG, 10);

		// Optional: limit to max if needed (uncomment if necessary)
		// const max = parseInt($(input).attr('max'), 10);
		// const safeVal = Math.min(val, max);

		// Sync hidden input and send to cart
		$(input).val(val);

		const id = $(input).attr('data-id');
		const index = $(input).attr('data-index');
		console.log('Input updated. ID:', id, 'Index:', index, 'Qty:', val);
		addToCartSingle.delayedSendQty(id, index, pack, val);
	},

    onQuantityPlus: function() {
		let input;
		if($('body .search-results').length > 0) {
			input = $(this).parent().find('.js-search-res-input');
		} else {
			input = $(this).parent().find('input:last');
		}
		const inputpack = $(this).parent().find('input:first');
		const id = $(this).attr('data-id');
		const index = $(this).attr('data-index');
		const pack = 1;

		let currentVal = parseInt(input.val(), 10) || 0;
		currentVal++;

		if (!addToCartSingle.$flag) {
			input.val(currentVal); // Update input value
			inputpack.val(currentVal);
            console.log('addToCart.onQuantityPlus');
			addToCartSingle.delayedSendQty(id, index, pack, currentVal);
		}
	},

    onQuantityMinus: function() {
		let input;
		if($('body .search-results').length > 0) {
			input = $(this).parent().find('.js-search-res-input');
		} else {
			input = $(this).parent().find('input:last');
		}
		const inputpack = $(this).parent().find('input:first');
		const id = $(this).attr('data-id');
		const index = $(this).attr('data-index');
		const pack = 1;

		let currentVal = parseInt(input.val(), 10) || 0;

		if (currentVal > 0) {
			currentVal--;
		}

		if (!addToCartSingle.$flag) {
			input.val(currentVal > 0 ? currentVal : ''); // Keep empty if 0
			inputpack.val(currentVal);
            console.log('addToCart.onQuantityMinus');
			addToCartSingle.delayedSendQty(id, index, pack, currentVal);
		}

		if (currentVal === 0) {
			currentVal = '';
		}
	},

    onSingleProductQuantityKeyUp: function(event) {
        // not sure are we need this code
        if (event.keyCode === 13) {
            const val = $(this).val();
            const id = $(this).attr('data-id');
            if (val >= 0) {
                const url = kadraGlobal.baseUrl + 'add_many_to_cart?id=' + id + '&value=' + val;
                addToCartSingle.sendData(url);
            } else {
                $(this).val(0);
            }
        }
    },

	delayedSendQty(ProductId, Index, Pack, Qty) {
        clearTimeout(addToCartSingle.CartUpdateTimeout[ProductId]);
		addToCartSingle.CartUpdateTimeout[ProductId] = setTimeout(function() {
			console.log('Triggered delayedSendQty for Product:', ProductId, 'Index:', Index);
            $('body').css('pointer-events', 'none');
            $('body').css('opacity', '0.7');
			const url = kadraGlobal.baseUrl + 'add_many_to_cart?id=' + ProductId + '&value=' + Qty;

            addToCartSingle.sendDataMany(url, Qty * Pack, Index);
			/* addToCartSingle.$index = Index; */
			addToCartSingle.hideShow(true, null, Index);
			addToCartSingle.hideShowSingle();
        }, 1000);
	},

	sendDataMany: (url, sum, index) => {
		console.log('Sending AJAX to:', url, 'Sum:', sum, 'Index:', index);
		addToCartSingle.$flag = true;
		$.ajax({
			url: url,
			type: 'GET',
			success: function(result) {
				console.log('AJAX success, updating cart header, Index:', index);
                $(addToCartSingle.$cartHeader).html(result);
				addToCartSingle.hideShow(false, sum, index);
				addToCartSingle.$flag = false;
				addToCartSingle.afterAjax();
			},
			error: function() {
				console.log('AJAX error');
				addToCartSingle.$flag = false;
				addToCartSingle.afterAjax();
			}
		});
	},
	hideShow: (flag, sum = 0, index) => {
		/* const index = addToCartSingle.$index; */
		console.log('hideShow called. Flag:', flag, 'Sum:', sum, 'Index:', index);
		if (flag) {
			$('.js-case-yes-' + index).hide();
			$('.js-case-no-' + index).hide();
			$('.js-case-loader-' + index).show();
		} else {
			if (sum > 0) {
				$('.js-case-yes-' + index).show();
				$('.js-case-no-' + index).hide();
			} else {
				$('.js-case-yes-' + index).hide();
				$('.js-case-no-' + index).show();
			}
			$('.js-case-loader-' + index).hide();
		}
	},
	hideShowSingle: () => {
		$('.js-single-case').hide();
		$('.js-single-case-check').hide();
		$('.js-single-case-processing').show();
	},
	afterAjax: () => {
		console.log('Running afterAjax');
		if (parseInt($('#singleInput').val()) !== 0) {
			$('.js-single-case-check').show();
			if ($('#cartId').html() > 99) {
				$('#cartId').addClass('bigger');
			} else {
				$('#cartId').removeClass('bigger');
			}
		} else {
			$('.js-single-case').show();
		}
		$('.js-single-case-processing').hide();

		$('body').css('opacity', '1');
		$('body').css('pointer-events', 'auto');
	},
	setHeader: (flag, sum) => {
		let total = parseInt(kadraGlobal.cartTotal);
		(flag === 'plus') ? total += 1 : total -= 1;
		kadraGlobal.cartTotal = total;
		$(addToCartSingle.$cartHeader).html(total);
		addToCartSingle.hideShow(false, sum);
	},
	sendData: (url) => {
		addToCartSingle.$flag = true;
		$.ajax({
			url: url,
			type: 'GET',
			success: function(result) {
				$(addToCartSingle.$cartHeader).html(result);
				addToCartSingle.hideShow(false, result);
				addToCartSingle.$flag = false;
				addToCartSingle.afterAjax();
			},
			error: function() {
			}
		});
	}
};

export default addToCartSingle;
